import { useState } from 'react';
import { DashboardFormWrapper } from '../dashboard';
import { ContainersPage } from './ContainersComponents';
import { ContainersAddHeader, ContainersAddForm } from './ContainersAddComponents';
import { RoleGuard } from '../../routes';

export const ContainersAdd = () => {
  const [count, setCount] = useState(1);

  return (
    <RoleGuard roles={'admin'}>
      <ContainersPage>
        <ContainersAddHeader count={count} />
        <DashboardFormWrapper flow={'row'}>
          <ContainersAddForm setCount={setCount} />
          <ContainersAddHeader showOnlySubmit />
        </DashboardFormWrapper>
      </ContainersPage>
    </RoleGuard>
  );
};
